import React from 'react'
import { string, bool } from 'prop-types'
import classnames from 'classnames'

import storage from 'utils/storage'

import Button from 'components/atoms/Button'
import { SVGIcon } from 'components/qstrap'

const InterestButton = ({ id, interested, enabled }) => {
  const toggleInterest = (e) => {
    e.preventDefault()
    if (enabled) {
      const selectedSchool = storage.select('serverProps', 'schoolRecommendation', { id })
      const currentInterest = selectedSchool.get('interested')
      selectedSchool.set('interested', !currentInterest)

      const currentSelectedIds = storage.get('common', 'selectedIds')
      const selectedIds = storage.select('common', 'selectedIds')

      if (currentSelectedIds.indexOf(id) > -1) {
        selectedIds.set(
          currentSelectedIds.filter(selectedId => selectedId !== id)
        )
      } else {
        selectedIds.push(id)
      }
    }
  }

  return (
    <Button
      component="button"
      type="button"
      className={classnames('interest-btn', {
        'interest-btn--checked': interested,
        'interest-btn--disabled': !enabled,
      })}
      onClick={toggleInterest}
      disabled={!enabled}
    >

      <span className="interest-btn__content">
        { !interested && 'Saya Tertarik' }
        { interested &&
          <>
            <SVGIcon size="sm" name="tick" /> Tertarik
          </>
        }
      </span>
      <style jsx global>
        {`
          .interest-btn {
            cursor: pointer;
            width: 100%;
            border: none;
            font-weight: bold;
            &.interest-btn--checked {
              background: #fff;
              color: #8fb0d4;
              display: flex;
              align-items: center;
              border: solid 1px #8fb0d4;
            }
            &.interest-btn--disabled {
              cursor: not-allowed;
            }
          }
        `}
      </style>
    </Button>
  )
}

InterestButton.propTypes = {
  id: string,
  interested: bool,
  enabled: bool,
}

InterestButton.defaultProps = {
  enabled: true,
}

export default InterestButton
